// extracted by mini-css-extract-plugin
export default {"description":"description-F5RIn9kF"};